import { twMerge } from "tailwind-merge";

import { SectionHeader } from "~/common/components/ui";
import {
  PREVIEW_TITLE_CODES,
  previewSectionCodeToLabel,
} from "~/providers/constants/SummariesExpandableIds";
import { getPreviewFunctionalDomainsIcon } from "~/providers/utils/getPreviewFunctionalDomainsIcon";
import {
  FUNCTIONAL_DOMAIN_KEY,
  FUNCTIONAl_DOMAINS_KEY_OPTIONS,
  FunctionalDomainsV2 as FunctionalDomainsV2Type,
} from "~/providers/utils/types/patientIntakePreviewTypes";
import Expandable from "../../common/Expandable";
import { FunctionalDomainsTitle } from "./FunctionalDomainsTitle";
import { Inquiries } from "./Inquiries/Inquiries";

interface FunctionalDomainsV2Props {
  functionalDomains: FunctionalDomainsV2Type[];
}

export const FunctionalDomainsV2 = ({
  functionalDomains,
}: FunctionalDomainsV2Props) => (
  <Expandable.Wrapper
    title={<FunctionalDomainsTitle />}
    code={PREVIEW_TITLE_CODES.FUNCTIONAL_DOMAINS}
    className="gap-0 p-0"
    expandableSections={[...FUNCTIONAl_DOMAINS_KEY_OPTIONS]}
  >
    {functionalDomains.map(
      (
        { direct_inquiry, indirect_inquiry, may_indicate, narrative, section },
        index,
      ) => (
        <Expandable.Section
          key={FUNCTIONAL_DOMAIN_KEY[section]}
          className={twMerge(
            "px-3 py-2",
            index === functionalDomains.length - 1 && "border-none",
          )}
          code={FUNCTIONAL_DOMAIN_KEY[section]}
          icon={getPreviewFunctionalDomainsIcon(
            direct_inquiry.classification,
            indirect_inquiry.classification,
            section,
          )}
          title={
            <div className="text-left">
              <p className="-mt-0.5 flex-1 text-left text-xs font-semibold text-gray-60 first-letter:capitalize">
                {may_indicate}
              </p>
              <div className="flex">
                <SectionHeader className="mb-1 min-w-64 text-lg font-semibold leading-none first-letter:uppercase">
                  {previewSectionCodeToLabel[FUNCTIONAL_DOMAIN_KEY[section]]}
                </SectionHeader>
              </div>
              <p className="text-sm first-letter:capitalize">{narrative}</p>
            </div>
          }
        >
          <Inquiries
            directInquiry={direct_inquiry}
            indirectInquiry={indirect_inquiry}
          />
        </Expandable.Section>
      ),
    )}
  </Expandable.Wrapper>
);
